// extracted by mini-css-extract-plugin
export default {"colorOption":"ColorOption_colorOption__NT-b+"};